module.exports = __webpack_public_path__ + "static/2-35ad7a98c1b7cfbc851710a38cd6900e.png";